import { API_URL } from "@/constants/envVariables";

import { fetchApi } from "@/helpers/fetchApi";

export type DataExplorerUser = {
  tenant_name: string;
  receiver_id: string;
  email?: string;
  phone_number?: string;
  stellar_address?: string;
  external_id?: string;
};

export type DataExplorerUsersResponse = {
  users: DataExplorerUser[];
  pagination: {
    page: number;
    page_limit: number;
    total: number;
    pages: number;
  };
  warnings?: string[];
};

export const getDataExplorerUsers = async (params?: {
  tenant?: string;
  q?: string;
  page?: number;
  page_limit?: number;
}): Promise<DataExplorerUsersResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.tenant) searchParams.set("tenant", params.tenant);
  if (params?.q) searchParams.set("q", params.q);
  if (params?.page) searchParams.set("page", String(params.page));
  if (params?.page_limit) searchParams.set("page_limit", String(params.page_limit));

  const qs = searchParams.toString();
  const url = `${API_URL}/admin/data-explorer/users${qs ? `?${qs}` : ""}`;

  return fetchApi(url) as Promise<DataExplorerUsersResponse>;
};
